import { cloneDeep } from "lodash";
import React, { useState } from "react";
import MMPopup from "../../../../mmcomponents/mmpopup/MMPopup";
import MMTabs from "../../../../mmcomponents/mmtabs/MMTabs";
import { Icon } from "../../../../_foundation/_buttons";
import ElementDesign from "../../elements/popups/ElementDesign";
import ElementSettings from "../../elements/popups/ElementSettings";

const tabs = {
  design: {
    name: "Design",
    icon: "paint-brush",
  },
  settings: {
    name: "Einstellungen",
    icon: "cog",
  },
};

function AreaPopup(props) {
  const [area, setArea] = useState(cloneDeep(props.area));
  const [unsavedChanges, setUnsavedChanges] = useState(false);
  const [selectedTab, setSelectedTab] = useState("design");

  const onEdit = (property, value) => {
    console.log("P", property, value);
    const updatedArea = cloneDeep(area);

    if (property.substring(0, 8) === "options.") {
      let { options } = updatedArea;
      if (!options) options = {};
      options[property.replace("options.", "")] = value;
      updatedArea.options = options;
    } else {
      updatedArea[property] = value;
    }

    setArea(updatedArea);
    setUnsavedChanges(true);
  };

  const onUpdate = () => {
    if (props.actions.onUpdateArea) props.actions.onUpdateArea(area);
  };

  const actions = {
    onEdit,
    onUpdate,
  };

  const onCancel = () => {
    if (
      !unsavedChanges ||
      (unsavedChanges &&
        window.confirm(
          "Möchtest Du wirklich abbrechen? Änderungen gehen unwiderruflich verloren."
        ) &&
        props.onCancel)
    )
      props.onCancel();
  };

  return (
    <div className="pagebuilder-area-popup">
      <MMPopup size="medium" show={true} handleClose={onCancel}>
        <h3>Bereich bearbeiten</h3>
        <div className="admin-tabs">
          <MMTabs
            tabs={tabs}
            selected={selectedTab}
            onUpdate={(selectedKeyName) => setSelectedTab(selectedKeyName)}
          />
        </div>
        {selectedTab === "design" && (
          <ElementDesign item={area} itemType="area" actions={actions} />
        )}
        {selectedTab === "settings" && (
          <ElementSettings item={area} itemType="area" actions={actions} />
        )}
        <div className="text-right">
          <button className="small primary hollow button" onClick={onCancel}>
            <Icon icon="times" left /> Abbrechen
          </button>
          <button className="small primary button" onClick={onUpdate}>
            <Icon icon="check" left /> Übernehmen
          </button>
        </div>
      </MMPopup>
    </div>
  );
}

export default AreaPopup;
